import getAxiosInstance from "../config/http";

export const uploadFile = async (formData) => {
  const http = getAxiosInstance();
  const data = await http.post(`/upload`, formData);
  return data.data;
};
